import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {required as validateRequired} from '@cred/shared/validations'
import {Label} from '@cred/react-label'
import {Text} from '@cred/react-text'
import rollbar from '@cred/shared/rollbar'
import {resolve} from '@cred/shared/utils'
import loadGoogleMapsApi from 'load-google-maps-api'
import config from 'config'
import {
  Input,
  Link,
  Dropdown,
  textInputWithAnalytics,
  zipInputWithAnalytics,
  selectCustomWithAnalytics,
  AddressSearch
} from '../components'
import styles from './styles.module.scss'
import pure from 'purecss/build/pure.css'
import grid from 'purecss/build/grids-responsive.css'

const states = [
  {value: 'AL', label: 'Alabama'},
  {value: 'AK', label: 'Alaska'},
  {value: 'AZ', label: 'Arizona'},
  {value: 'AR', label: 'Arkansas'},
  {value: 'CA', label: 'California'},
  {value: 'CO', label: 'Colorado'},
  {value: 'CT', label: 'Connecticut'},
  {value: 'DE', label: 'Delaware'},
  {value: 'DC', label: 'District of Columbia'},
  {value: 'FL', label: 'Florida'},
  {value: 'GA', label: 'Georgia'},
  {value: 'HI', label: 'Hawaii'},
  {value: 'ID', label: 'Idaho'},
  {value: 'IL', label: 'Illinois'},
  {value: 'IN', label: 'Indiana'},
  {value: 'IA', label: 'Iowa'},
  {value: 'KS', label: 'Kansas'},
  {value: 'KY', label: 'Kentucky'},
  {value: 'LA', label: 'Louisiana'},
  {value: 'ME', label: 'Maine'},
  {value: 'MD', label: 'Maryland'},
  {value: 'MA', label: 'Massachusetts'},
  {value: 'MI', label: 'Michigan'},
  {value: 'MN', label: 'Minnesota'},
  {value: 'MS', label: 'Mississippi'},
  {value: 'MO', label: 'Missouri'},
  {value: 'MT', label: 'Montana'},
  {value: 'NE', label: 'Nebraska'},
  {value: 'NV', label: 'Nevada'},
  {value: 'NH', label: 'New Hampshire'},
  {value: 'NJ', label: 'New Jersey'},
  {value: 'NM', label: 'New Mexico'},
  {value: 'NY', label: 'New York'},
  {value: 'NC', label: 'North Carolina'},
  {value: 'ND', label: 'North Dakota'},
  {value: 'OH', label: 'Ohio'},
  {value: 'OK', label: 'Oklahoma'},
  {value: 'OR', label: 'Oregon'},
  {value: 'PA', label: 'Pennsylvania'},
  {value: 'RI', label: 'Rhode Island'},
  {value: 'SC', label: 'South Carolina'},
  {value: 'SD', label: 'South Dakota'},
  {value: 'TN', label: 'Tennessee'},
  {value: 'TX', label: 'Texas'},
  {value: 'UT', label: 'Utah'},
  {value: 'VT', label: 'Vermont'},
  {value: 'VA', label: 'Virginia'},
  {value: 'WA', label: 'Washington'},
  {value: 'WV', label: 'West Virginia'},
  {value: 'WI', label: 'Wisconsin'},
  {value: 'WY', label: 'Wyoming'}
]

class FullAddress extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    change: PropTypes.func.isRequired,
    autoFocus: PropTypes.bool,
    singleLine: PropTypes.bool,
    required: PropTypes.bool,
    analyticsContexts: PropTypes.array,
    fieldNameStyle: PropTypes.oneOf(['snake', 'camel'])
  }

  static defaultProps = {
    autoFocus: false,
    loadingComponent: null,
    autoComplete: 'off',
    singleLine: false,
    required: true,
    onToggleAddress: () => {},
    analyticsContexts: [],
    fieldNameStyle: 'snake'
  }

  static displayName = 'FullAddress'

  constructor(props) {
    super(props)

    this.state = {manual: false}

    this.handleToggleMode = this.handleToggleMode.bind(this)
    this.handleSelectAddress = this.handleSelectAddress.bind(this)
    this.validateFullAddress = this.validateFullAddress.bind(this)
    this.handleFullAddressBlur = this.handleFullAddressBlur.bind(this)
  }

  getFullAddressFieldName = () => {
    const {fieldNameStyle} = this.props

    return fieldNameStyle === 'snake' ? 'full_address' : 'fullAddress'
  }

  componentDidMount() {
    const {formData, name} = this.props,
      formValues = formData ? formData.values : formData,
      values = formValues ? resolve(name, formValues) : {}

    loadGoogleMapsApi({
      key: config.googleMapsApiKey,
      libraries: ['places']
    })
      .then(() => {
        this.setState({googleMapsLoaded: true})
      })
      .catch(error => {
        rollbar.error('Error loading Google Maps Api', error)
      })

    if (
      values &&
      !values[this.getFullAddressFieldName()] &&
      values.street &&
      values.city &&
      values.state &&
      values.zipcode
    ) {
      this.setState({manual: true})
    }
  }

  render() {
    const {
        name,
        title,
        placeholder,
        className,
        autoFocus,
        loadingComponent,
        autoComplete,
        singleLine,
        required,
        analyticsContexts
      } = this.props,
      searchGrid = singleLine
        ? [grid['pure-u-lg-2-3'], pure['pure-u-1']].join(' ')
        : pure['pure-u-1'],
      unitGrid = singleLine
        ? [grid['pure-u-lg-1-3'], pure['pure-u-1']].join(' ')
        : pure['pure-u-1']

    if (this.state.manual) {
      return (
        <div className={className}>
          <Label>{title}</Label>
          <div className={styles.manual}>
            <div className={[pure['pure-g'], styles.address].join(' ')}>
              <div className={pure['pure-u-1']}>
                <Input
                  analyticsContexts={analyticsContexts}
                  autoFocus={autoFocus}
                  sensitive={true}
                  type="text"
                  label="Address (street)"
                  placeholder="Address (street)"
                  name={`${name}.street`}
                  component={textInputWithAnalytics}
                  validate={validateRequired}
                  className="mt-16"
                />
              </div>
              <div className={pure['pure-u-1']}>
                <Input
                  analyticsContexts={analyticsContexts}
                  type="text"
                  label="Unit (Optional)"
                  placeholder="Unit (Optional)"
                  name={`${name}.unit`}
                  component={textInputWithAnalytics}
                  className="mt-16"
                />
              </div>
              <div className={pure['pure-u-1']}>
                <Input
                  analyticsContexts={analyticsContexts}
                  type="text"
                  label="City"
                  name={`${name}.city`}
                  placeholder="City"
                  component={textInputWithAnalytics}
                  validate={validateRequired}
                  className="mt-16"
                />
              </div>
              <div className={pure['pure-u-1']}>
                <Dropdown
                  label="State"
                  placeholder="State"
                  type="text"
                  name={`${name}.state`}
                  options={states}
                  validate={validateRequired}
                  component={selectCustomWithAnalytics}
                  analyticsContexts={analyticsContexts}
                  className="dropdown-custom mt-16"
                />
              </div>
              <div className={pure['pure-u-1']}>
                <Input
                  analyticsContexts={analyticsContexts}
                  type="tel"
                  label="ZIP code"
                  name={`${name}.zipcode`}
                  placeholder="ZIP code"
                  component={zipInputWithAnalytics}
                  validate={validateRequired}
                  className="mt-16"
                />
              </div>
              <div className={pure['pure-u-1']}>
                <Text type="caption" className="mt-16">
                  Switch back to{' '}
                  <Link
                    analyticsContexts={analyticsContexts}
                    onClick={this.handleToggleMode}
                  >
                    address search
                  </Link>
                </Text>
              </div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className={[pure['pure-g'], styles.address, className].join(' ')}>
          <div className={searchGrid}>
            {this.state.googleMapsLoaded ?
              <AddressSearch
                name={`${name}.${this.getFullAddressFieldName()}`}
                label={title}
                placeholder={placeholder}
                onSelectAddress={this.handleSelectAddress}
                onBlur={this.handleFullAddressBlur}
                validate={this.validateFullAddress}
                autoComplete={autoComplete}
                autoFocus={autoFocus}
                className={singleLine ? 'mr-lg-8' : ''}
                analyticsContexts={analyticsContexts}
              />
             :
              <div>
                <Input
                  type="hidden"
                  name={`${name}.${this.getFullAddressFieldName()}`}
                  validate={required ? validateRequired : null}
                />
                {loadingComponent}
              </div>
            }
            <Text
              type="caption"
              className={singleLine ? 'mt-8 mb-16 mb-lg-0' : 'mt-8 mb-16'}
            >
              Can't find the address?{' '}
              <Link
                analyticsContexts={analyticsContexts}
                onClick={this.handleToggleMode}
              >
                Enter it manually
              </Link>
            </Text>
          </div>
          <div className={unitGrid}>
            <Input
              type="text"
              label="Unit (Optional)"
              placeholder="Unit (Optional)"
              name={`${name}.unit`}
              component={textInputWithAnalytics}
              className={singleLine ? 'ml-lg-8' : ''}
              analyticsContexts={analyticsContexts}
            />
          </div>
        </div>
      )
    }
  }

  handleSelectAddress(addressData) {
    const {name, change} = this.props

    change(`${name}.street`, addressData.street)
    change(`${name}.city`, addressData.city)
    change(`${name}.state`, addressData.state)
    change(`${name}.zipcode`, addressData.zipcode)
    change(`${name}.${this.getFullAddressFieldName()}`, addressData.fullAddress)
    this.setState({lastFullAddress: addressData.fullAddress})

    if (!addressData.complete) {
      alert('Could not find your full address. Please enter details manually')
      this.setState({manual: true})
    }
  }

  handleFullAddressBlur(e) {
    const {name, change} = this.props

    change(`${name}.${this.getFullAddressFieldName()}`, this.state.lastFullAddress)
    e.preventDefault()
  }

  handleToggleMode() {
    const {name, change, onToggleAddress} = this.props

    if (this.state.manual) {
      this.setState({lastFullAddress: ''})
      change(`${name}.${this.getFullAddressFieldName()}`, '')
    }

    this.setState({manual: !this.state.manual})

    onToggleAddress(!this.state.manual)
  }

  validateFullAddress(value) {
    const {formData, name, required} = this.props,
      formValues = formData ? formData.values : formData,
      values = formValues ? resolve(name, formValues) : null

    let validation

    if (required) {
      validation = validateRequired(value) || validateRequired(values)
    }

    if (!validation && values) {
      validation =
        validateRequired(values.street) ||
        validateRequired(values.city) ||
        validateRequired(values.state) ||
        validateRequired(values.zipcode)
    }

    return validation
  }
}

export {FullAddress}

export default FullAddress
